import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/components/LandingNavbar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/ui/AppLogo.tsx");
